import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export const AuthInput = ({ err, mask, value, onChange, placeholder }) => {
  const style = {};
  if (err) {
    style.border = '1px solid red';
  }

  const handleChange = ({ target: { value } }) => {
    onChange(value);
  };

  if (mask) {
    return (
      <InputMask
        maskChar="X"
        formatChars={{
          9: '[0-9]',
          A: '[А-Я]',
        }}
        mask={mask}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      >
        {(inputProps) => (
          <div className="input-form">
            <input {...inputProps} style={style} className="input" />
          </div>
        )}
      </InputMask>
    );
  } else {
    return (
      <div className="input-form">
        <input className="input" value={value} placeholder={placeholder} onChange={handleChange} style={style} />
      </div>
    );
  }
};

AuthInput.propTypes = {
  err: PropTypes.bool,
  mask: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

AuthInput.defaultProps = {
  err: false,
  onChange: () => {},
};
